import gql from 'graphql-tag'

export default gql`
  mutation updateSocialNetwork($id: Int!, $name: String!, $url: String!, $image: String!) {
    updateSocialNetwork(id: $id, input: { name: $name, url: $url, image: $image }) {
      id,
      name,
      url,
      image
    }
  }
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/social-network/update.js